module.exports = __webpack_public_path__ + "images/stickers/taco-clean@2x.997c0dfcf97f6f6fa5eb.png";